module.exports = __webpack_public_path__ + "img/sms-icon.7d5389c0.svg";